<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { NConfigProvider, NMessageProvider, NDialogProvider, NNotificationProvider, darkTheme } from 'naive-ui';
import AppToaster from '@/components/ui/AppToaster.vue';
import { setAuthToken } from '@/services/api';

const router = useRouter();

const handleUnauthorized = () => {
  console.warn('Session expired or unauthorized request detected. Redirecting to login...');
  setAuthToken(null);
  router.push('/auth/login');
};

onMounted(() => {
  window.addEventListener('auth:unauthorized', handleUnauthorized);
});

onUnmounted(() => {
  window.removeEventListener('auth:unauthorized', handleUnauthorized);
});
</script>

<template>
  <NConfigProvider :theme="darkTheme">
    <NMessageProvider>
      <NDialogProvider>
        <NNotificationProvider>
          <div class="min-h-screen bg-slate-950 text-slate-100 font-sans">
            <router-view />
            <AppToaster />
          </div>
        </NNotificationProvider>
      </NDialogProvider>
    </NMessageProvider>
  </NConfigProvider>
</template>